export default {
  solicitarBaixaMei: state => state.redeSIM.solicitarBaixaMei
};
